import axios from 'axios'
import router from '../../router'
import { Loading } from 'element-ui'
import { Message } from 'element-ui'
let configBaseURL = process.env.VUE_APP_API //全局环境变量

let loadingInstance = null //这里是loading
//使用create方法创建axios实例
const Service = axios.create({
  timeout: 5000, // 请求超时时间
  baseURL: configBaseURL,
})
Service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 添加请求拦截器
Service.interceptors.request.use(config => {
  loadingInstance = Loading.service({
    lock: true,
    text: 'loading...'
  })
  if(localStorage.getItem('Token')){// 每次发送请求之前判断是否存在token
    config.headers['Authorization']='Bearer '+localStorage.getItem('Token');
  }
  return config
})
// 添加响应拦截器
Service.interceptors.response.use(response => {
  loadingInstance.close()
  if(response.data && response.data.code===0){
    return response.data
  }else{
    Message.error(response.data.message)
    switch(response.data.code){
      case  20000:
        localStorage.clear()
        router.replace({                        
          path: '/login',                        
          query: { 
              redirect: router.currentRoute.fullPath 
          }
        });
        break;
    }
  }
}, error => {
  loadingInstance.close()
  if(error && error.response){
    router.replace({                        
        path: '/error',                        
        query: { 
          error: JSON.stringify(error.response.data)
        }
    });
  }
  return error
})
export default Service